import React, { useEffect, useMemo, useState } from "react";
import { Card, Container, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Select from "react-select";

// Components
import ProjectCodeList from "./components/tables/ProjectCodeList";
import MinistryOptions from "./components/filters/MinistryOptions";

// Redux
import {
  fetchMinistries,
  getProjectsByMinistry,
  setSelectDepartment,
  setSelectMinistry,
} from "../../../redux/slices/others/projectCodeSlice";
import {
  getMainProjects,
  getOptions,
  getPrograms,
  getRmkItems,
  setRmkValue,
} from "../../../redux/slices/utilsSlice";
import EditForm from "./components/modals/EditForm";
import CodeEditingList from "./components/tables/CodeEditingList";

const MainPage = () => {
  const dispatch = useDispatch();

  const { rmkOptions, rmkValue, currentRmk, selectMinistry, selectDepartment } =
    useSelector((state) => ({
      rmkOptions: state.utilsReducer.dropdownItems.rmkItems,
      rmkValue: state.utilsReducer.rmkValue,
      currentRmk: state.rmkReducer.activeRmk,
      selectMinistry: state.projectCodeReducer.selectMinistry,
      selectDepartment: state.projectCodeReducer.selectDepartment,
    }));

  const [openForm, setOpenForm] = useState(false);
  const [data, setData] = useState(null);

  const handleSelectMinistries = (e, ministry) => {
    dispatch(setSelectMinistry(ministry));
    if (selectMinistry !== ministry) {
      dispatch(setSelectDepartment(null));
    }
  };

  const handleEditItem = (items) => {
    setData(items);
    setOpenForm(true);
  };

  useEffect(() => {
    if (!currentRmk) return;

    dispatch(setRmkValue(currentRmk));
  }, [dispatch, currentRmk]);

  useEffect(() => {
    let source = axios.CancelToken.source();

    const initialize = async () => {
      const props = {
        source: source,
      };

      await dispatch(getOptions(props));
      dispatch(getMainProjects(props));
      dispatch(getPrograms(props));
    };

    initialize();
    return () => {
      source.cancel();
    };
  }, [dispatch]);

  useEffect(() => {
    let source = axios.CancelToken.source();
    const props = {
      source: source,
      params: {
        ministry_id: selectMinistry,
        department: selectDepartment,
        rmk_id: rmkValue?.number || currentRmk.number,
      },
    };

    const initialize = async () => {
      await dispatch(fetchMinistries(props));

      if (selectMinistry !== null) {
        await dispatch(getProjectsByMinistry(props));
      }

      await dispatch(getRmkItems(props));
    };

    initialize();

    return () => {
      source.cancel();
    };
  }, [dispatch, selectMinistry, selectDepartment, rmkValue]);

  return (
    <React.Fragment>
      <EditForm
        showForm={openForm}
        hideForm={() => {
          setData(null);
          setOpenForm(false);
        }}
        data={data}
      />
      <Container fluid className='p-0'>
        <div className='d-flex'>
          <Form.Group className='mb-3' style={{ width: 140 }}>
            <Select
              placeholder='Pilih RMK'
              className='react-select-container'
              classNamePrefix='react-select'
              options={rmkOptions}
              value={rmkValue}
              onChange={(value) => dispatch(setRmkValue(value))}
              noOptionsMessage={() => "Tiada pilihan"}
            />
          </Form.Group>
        </div>
        <MinistryOptions handleSelectMinistries={handleSelectMinistries} />
        <Card>
          <Card.Body>
            {/* <ProjectCodeList handleEditItem={handleEditItem} /> */}
            <h5 className='mb-3'>{`Senarai Projek ${rmkValue?.name} (${rmkValue?.short_form})`}</h5>
            <CodeEditingList />
          </Card.Body>
        </Card>
      </Container>
    </React.Fragment>
  );
};

export default MainPage;
